module.exports = __webpack_public_path__ + "staticmedia/media/Roboto-Thin.8752feb5.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/fonts/Roboto-Thin.ttf
// module id = 113
// module chunks = 0